"use client";
import React from "react";

interface NotchProps {
  id: string;
  checked: boolean;
  onChange: () => void;
  labelText: string;
  disabled?: boolean;
}

export default function Notch({ 
  id, 
  checked, 
  onChange, 
  labelText, 
  disabled = false 
}: NotchProps) {
  return (
    <div className="flex items-center gap-3 w-full">
      <button
        type="button"
        id={id}
        onClick={disabled ? undefined : onChange}
        disabled={disabled}
        className={`
          relative inline-flex h-6 min-w-11 items-center rounded-full transition-colors duration-200 ease-in-out
          ${checked 
            ? 'bg-primary' 
            : 'bg-gray-300'
          }
          ${disabled 
            ? 'cursor-not-allowed opacity-50' 
            : 'cursor-pointer'
          }
        `}
        role="switch"
        aria-checked={checked}
        aria-labelledby={`${id}-label`}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out
            ${checked ? 'translate-x-6' : 'translate-x-1'}
          `}
        />
      </button>
      <label 
        htmlFor={id}
        id={`${id}-label`}
        className={`
          text-sm font-medium cursor-pointer select-none
          ${disabled ? 'text-gray-400' : 'text-gray-700'}
        `}
      >
        {labelText}
      </label>
    </div>
  );
}
